import {Component, HostBinding, Inject, OnInit} from '@angular/core';
import {TestResult} from '../../../data/models/result/test-result';
import {QuestionResult} from '../../../data/models/result/question-result';
import {TestResultService} from '../../../services/api/result/test-result.service';
import {QuestionResultService} from '../../../services/api/result/question-result.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-result-commit-dialog',
  templateUrl: './test-result-commit-dialog.component.html',
  styleUrls: ['./test-result-commit-dialog.component.css']
})
export class TestResultCommitDialogComponent implements OnInit {

  @HostBinding('class') class = 'app-test-result-finish-checking-dialog';

  testResult: TestResult;

  questionResults!: QuestionResult[];
  questionResultsErrors: string[] = [];
  questionResultsChecked = false;

  constructor(
    private testResultService: TestResultService,
    private questionResultService: QuestionResultService,
    public dialogRef: MatDialogRef<TestResultCommitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      testResult: TestResult,
    },
  ) {
    this.testResult = data.testResult;
    this.checkQuestionResults();
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testResultService.commitTestResult(this.testResult.id)
      .then(testResult => {
        this.dialogRef.close(testResult);
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  checkQuestionResults(): void {
    this.questionResultService.getQuestionResults(this.testResult.id)
      .then(questionResults => {
        this.questionResults = questionResults;
        if (questionResults.length === 0) {
          this.questionResultsErrors.push('В результате нет вопросов');
          this.questionResultsChecked = true;
          return;
        }

        const questionResultsNotChecked = [];

        let questionResultNumber = 1;
        for (const questionResult of questionResults) {
          if (questionResult.isCorrect === null) {
            questionResultsNotChecked.push(questionResultNumber);
          }
          questionResultNumber++;
        }

        if (questionResultsNotChecked.length > 0) {
          this.questionResultsErrors.push(`Непроверенные ответы: ${questionResultsNotChecked.join(', ')}.`);
        }

        this.questionResultsChecked = true;
      });
  }

}
